import { gql } from '@biletiniz/apollo';

export const RESEND_CODE = gql`
  mutation resendCode($session:String!) {
    resendCode(session: $session) {
      message
      session
    }
  }
`;
